import {Button, Card, FormControl, FormField} from 'platform/components';
import {HStack, Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {GREETING_MAX_LENGTH, TelephonyLineFormValues} from '../utils/telephonyLineForm';

const GREETING_MIN_ROWS = 3;

interface TelephonyLineGreetingsCardProps extends RequiredTestIdProps {
  control: FormControl<TelephonyLineFormValues>;
  isReadOnly: boolean;
  hasCustomRouting: boolean;
  onOpenRouting: () => void;
}

export function TelephonyLineGreetingsCard(props: TelephonyLineGreetingsCardProps) {
  return (
    <Card
      title={i18n.t('page.settings.telephony.greetingsCardTitle')}
      data-testid={suffixTestId('card', props)}
    >
      <VStack spacing={4}>
        <Text color="secondary" size="small">
          {i18n.t('page.settings.telephony.greetingsDescription')}
        </Text>
        <FormField
          control={props.control}
          type="textarea"
          name="greetingIntro"
          label={i18n.t('page.settings.telephony.greetingsIntro')}
          minRows={GREETING_MIN_ROWS}
          maxLength={GREETING_MAX_LENGTH}
          isDisabled={props.isReadOnly}
          data-testid={suffixTestId('intro', props)}
        />
        <FormField
          control={props.control}
          type="textarea"
          name="greetingOutOfHours"
          label={i18n.t('page.settings.telephony.greetingsOutOfHours')}
          minRows={GREETING_MIN_ROWS}
          maxLength={GREETING_MAX_LENGTH}
          isCounterVisible
          helperText={i18n.t('page.settings.telephony.spokenTextLengthHint')}
          isDisabled={props.isReadOnly}
          data-testid={suffixTestId('outOfHours', props)}
        />
        {props.hasCustomRouting ? (
          <HStack spacing={2} align="center" wrap>
            <Text color="secondary" size="small">
              {i18n.t('page.settings.telephony.greetingsOutOfHoursRoutingHint')}
            </Text>
            <Button
              variant="link"
              size="small"
              title={i18n.t('page.settings.telephony.greetingsOpenRouting')}
              onClick={props.onOpenRouting}
              data-testid={suffixTestId('openRouting', props)}
            />
          </HStack>
        ) : (
          <Text color="secondary" size="small">
            {i18n.t('page.settings.telephony.greetingsOutOfHoursPlaysHint')}
          </Text>
        )}
      </VStack>
    </Card>
  );
}
